import { render, staticRenderFns } from "./SurveyReadView.vue?vue&type=template&id=e667654c"
import script from "./SurveyReadView.ts?vue&type=script&lang=ts&external"
export * from "./SurveyReadView.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports